export const saitgaraev = {
  id: 'saitgaraev',
  name: {
    ru: 'Сайтгараев Мерден Серикович',
    kz: 'Сайтгараев Мерден Серікұлы',
  },
  position: {
    ru: 'Врач-реабилитолог отделения физиотерапии, лечебной физкультуры и массажа',
    kz: 'Физиотерапия, емдік дене шынықтыру және массаж бөлімінің дәрігер-реабилитологы',
  },
  department: 'physiotherapy',
  image: '/team_photoes/new/saitgaraev.png',
  education: {
    ru: `2019 — Медицинский университет города Астана`,
    kz: `2019 — Астана қаласының медицина университеті`,
  },
  work: {
    ru: `• ТОО «Клиника IV Plus»`,
    kz: `• «Клиника IV Plus» ЖШС`,
  },
};
